<template>
    <BasicDrawer :duration="duration / 1000" ref="basicDrawerRef" v-if="show">
        <template v-slot:header>
            <div class="cancel-button" @click="closeDrawer">取消</div>

            <div class="header-title">
                选择优惠券
            </div>

            <div class="confirm-button" @click="confirm">确认</div>
        </template>

        <template>
            <div class="coupon-box">
                无可用优惠券
            </div>
        </template>
    </BasicDrawer>
</template>

<script>
import BasicDrawer from "./BasicDrawer.vue";

export default {
    name: "CouponDrawer",
    components: {
        BasicDrawer,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        duration: {
            type: Number,
            default: 200,
        },
    },
    data() {
        return {};
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.currentTime = this.time;
            }
        },
    },
    methods: {
        closeDrawer() {
            if (this.$refs.basicDrawerRef) {
                this.$refs.basicDrawerRef.hiddenDrawer();
            }

            setTimeout(() => {
                this.$emit("close");
            }, this.duration);
        },

        confirm() {
            this.closeDrawer();
        },
    },
};
</script>

<style scoped lang="scss">
* {
    font-family: PingFang-SC;
}

::v-deep .drawer-box_header {
    font-size: 13px;
    color: #323233;
    font-weight: 600;

    .header-title {
        text-align: center;

        .title-tip {
            font-weight: 500;
            color: #999999;
            font-size: 12px;
            margin-top: 2px;
        }
    }

    .cancel-button,
    .confirm-button {
        cursor: pointer;
    }

    .confirm-button {
        color: #fc2b55;
    }
}

::v-deep .drawer-box_content {
    .coupon-box {
        height: 300px;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
